export const breakpoints = {
  breakpointXl: "1200px",
  breakpointLg: "1000px",
  breakpointMd: "768px",
  breakpointSm: "600px",
  breakpointXs: "480px",
  breakpointXxs: "440px",

  /* Breakpoints mais específicos */
  breakpointSmPlus: "640px",
  breakpointSmExtra: "720px",
} as const;
